var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('link',{attrs:{"rel":"stylesheet","href":"https://stackpath.bootstrapcdn.com/bootstrap/4.3.1/css/bootstrap.min.css"}}),_c('link',{attrs:{"rel":"stylesheet","type":"text/css","href":"jquery.weekcalendar.css"}}),_c('div',{staticClass:"booking-container"},[_c('BookingFlow')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }